// Gemeinsame Nachschlage-Logik für die festen Übersetzungstabellen
// (Sektoren, Materialkategorien). Die Datenbank kennt diese Namen nur auf
// Deutsch (teils englisch); die Tabellen liefern en/zh dazu.
//
// Tabellenformat: { "<exakter DB-Wert>": { en, zh, de?, alt?: [...] } }
//   de  – nur nötig, wenn der DB-Wert selbst nicht deutsch ist (z.B. "Steel")
//   alt – weitere Schreibweisen, die als Eingabe erkannt werden sollen
//         (z.B. die vom Backend gelieferten Übersetzungen)
//
// Erkannt wird ein Wert über den DB-Schlüssel, aber auch über seine en/zh/de-
// Übersetzung: Das Backend übersetzt Sektornamen teils schon selbst, und
// zwischengespeicherte Antworten können noch in der vorherigen Sprache sein.

export function normalizeLabelLang(lang) {
  const raw = String(lang || "").toLowerCase();
  if (raw.startsWith("de")) return "de";
  if (raw.startsWith("zh")) return "zh";
  return "en";
}

export function normalizeTerm(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s*\/\s*/g, "/")
    .replace(/\s+/g, " ");
}

export function buildLabelIndex(...tables) {
  const direct = new Map();
  const reverse = new Map();
  const put = (map, term, entry) => {
    const n = normalizeTerm(term);
    if (n && !map.has(n)) map.set(n, entry);
  };
  const entries = [];
  tables.forEach((table) => {
    Object.entries(table).forEach(([key, value]) => {
      const entry = { key, ...value };
      entries.push(entry);
      put(direct, key, entry);
    });
  });
  // Übersetzungen vor Alternativschreibweisen, damit eigene Werte gewinnen.
  entries.forEach((e) => [e.de, e.en, e.zh].forEach((v) => put(reverse, v, e)));
  entries.forEach((e) => (e.alt || []).forEach((v) => put(reverse, v, e)));
  return { direct, reverse };
}

export function findLabelEntry(index, value) {
  const n = normalizeTerm(value);
  if (!n) return null;
  return index.direct.get(n) || index.reverse.get(n) || null;
}

// Liefert den Anzeigenamen in der Sprache `lang`; unbekannte Werte kommen
// unverändert (getrimmt) zurück.
export function resolveLabel(index, value, lang) {
  const text = String(value ?? "").trim();
  if (!text) return "";
  const entry = findLabelEntry(index, text);
  if (!entry) return text;
  const l = normalizeLabelLang(lang);
  if (l === "de") return entry.de || entry.key;
  return entry[l] || text;
}
